<template>
  <v-container class="fill-height" fluid>
    <v-row>
      <v-col sm="2">
        <v-card outlined>
          <v-card-text class="pa-0">
            <v-row class="ma-0">
              <v-col sm="5" style="background:#01579B">
                <div class="justify-center text-center mt-2">
                  <v-icon large style="color:#FFF">hourglass_empty</v-icon>
                </div>
              </v-col>
              <v-col sm="7">
                <div class="text-center">
                  <div class="headline">
                    <number :delay="2" :duration="3"
                            :from="0" :to="pending" easing="Power1.easeOut"/>
                  </div>
                  <span class="caption"><small>Cmd pending</small></span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="2">
        <v-card outlined>
          <v-card-text class="pa-0">
            <v-row class="ma-0">
              <v-col sm="5" style="background:#01579B">
                <div class="mt-2  justify-center text-center">
                  <v-icon large style="color:#fff">storage</v-icon>
                </div>
              </v-col>
              <v-col sm="7">
                <div class="text-center">
                  <div class="headline">
                    <small>
                      <number :delay="2"
                              :duration="3" :from="0"
                              :to="commands" easing="Power1.easeOut"/>
                    </small>
                  </div>
                  <span class="caption"><small>Cmd cours</small></span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="2">
        <v-card outlined>
          <v-card-text class="pa-0">
            <v-row class="ma-0">
              <v-col sm="5" style="background:#01579B">
                <div class="mt-2 justify-center text-center">
                  <v-icon large style="color:#fff">info</v-icon>
                </div>
              </v-col>
              <v-col sm="7">
                <div class="text-center">
                  <div class="headline">
                    <small>
                      <number :delay="2" :duration="5" :from="0"
                              :to="requests" easing="Power1.easeOut"/>
                    </small>
                  </div>
                  <span class="caption"><small>Requêtes</small></span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="2">
        <v-card outlined>
          <v-card-text class="pa-0">
            <v-row class="ma-0">
              <v-col sm="5" style="background:#01579B">
                <div class="mt-2  justify-center text-center">
                  <v-icon large style="color:#fff">credit_card</v-icon>
                </div>
              </v-col>
              <v-col sm="7">
                <div class="text-center  darken-4">
                  <div class="headline">
                    <small>
                      <number
                          :delay="2"
                          :duration="3"
                          :from="0"
                          :to="push"
                          easing="Power1.easeOut"/>
                    </small>
                  </div>
                  <span class="caption"><small>Auto push</small></span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="2">
        <v-card outlined>
          <v-card-text class="pa-0">
            <v-row class="ma-0">
              <v-col sm="5" style="background:#01579B">
                <div class="mt-2  justify-center text-center">
                  <v-icon large style="color:#fff">bug_report</v-icon>
                </div>
              </v-col>
              <v-col sm="7">
                <div class="text-center">
                  <div class="headline">
                    <small>
                      <number :delay="2" :duration="3" :from="0"
                              :to="logsSyst" easing="Power1.easeOut" ref="number1"/>
                    </small>
                  </div>
                  <span class="caption"><small>Log du jour</small></span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="2">
        <v-card outlined>
          <v-card-text class="pa-0">
            <v-row class="ma-0">
              <v-col sm="5" style="background:#01579B">
                <div class="mt-2  justify-center text-center">
                  <v-icon large style="color:#fff">device_hub</v-icon>
                </div>
              </v-col>
              <v-col sm="7">
                <div class="text-center">
                  <div class="headline">
                    <small>
                      <number :delay="2" :duration="3"
                              :from="0" :to="disk" easing="Power1.easeOut" ref="number1"
                      />
                    </small>
                  </div>
                  <span class="caption"><small>Disk usage</small></span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="4">
        <v-card outlined>
          <v-toolbar dense style="background:#F5F5F5">
            <v-toolbar-title dense style="color:#607D8B;font-weight:bold">
              <small>
                <v-icon dark dense style="color:#01579B;font-weight:bold">mdi-server-network</v-icon>
                Utilisation de la
                Mémoire</small>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <apexchart
                v-if="seriesMemories.length > 0 && seriesMemories.every(val => !isNaN(val))"
                :options="optionsMemories"
                :series="seriesMemories"
                type="donut"
                width="100%"
                height="350"
            ></apexchart>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="4">
        <v-card outlined>
          <v-toolbar dense style="background:#F5F5F5">
            <v-toolbar-title dense style="color:#607D8B;font-weight:bold">
              <small>
                <v-icon dark dense style="color:#01579B;font-weight:bold">mdi-source-fork</v-icon>
                CPU {{ seriesCPU[0] }} Cores
                OS: {{ cpuname }}, {{ cpuVersion }}</small>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <apexchart
                :options="optionsCPU"
                :series="seriesCPU"
                type="donut"
                width="100%">
            </apexchart>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="4">
        <v-card outlined>
          <v-toolbar dense style="background:#F5F5F5">
            <v-toolbar-title dense style="color:#607D8B;font-weight:bold">
              <small>
                <v-icon dark dense style="color:#01579B;font-weight:bold">bug_report</v-icon>
                Logs et bugs du jour</small>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <apexchart
                :options="optionslogs"
                :series="serieslogs"
                type="donut"
                width="100%">
            </apexchart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12">
        <v-card outlined>
          <v-toolbar dense style="background:#F5F5F5">
            <v-toolbar-title dense style="color:#607D8B;font-weight:bold">
              <small>
                <v-icon dark dense style="color:#01579B;font-weight:bold">mdi-signal</v-icon>
                Trafic quotidien</small>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <div id="lineChart" ref="linechart" style="width:100%"></div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApexCharts from "apexcharts";
import apiClient from "../../config/api.js";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      lineChart: null,
      isMobile: isMobileDevice(),
      timer: '',
      title: "Dashboard",
      optionsMemories: {
        labels: ["totalRAM", "totalDisk", "freeDisk", "freeRam"],
        colors: ["#03A9F4", "#01579B", "#8b8b8e"],
        chart: {
          height: 350 // Add explicit height
        }
      },
      seriesMemories: [0, 0, 0],
      optionslogs: {
        labels: ["error logs", "info logs", "warn logs"],
        colors: ["#03A9F4", "#01579B", "#8b8b8e"],
        chart: {
          height: 350 // Add explicit height
        }
      },
      serieslogs: [0, 0, 0],
      optionsCPU: {
        labels: ["nbr CPU", " Average"],
        colors: ["#03A9F4", "#01579B"],
        chart: {
          height: 350 // Add explicit height
        }
      },

      seriesCPU: [0, 0],
      loading: false,
      results: [],
      pending: 0,
      commands: 0,
      requests: 0,
      push: 0,
      logsSyst: 0,
      disk: 0,
      cpuname: "",
      cpuVersion: "",
      valuesLine: [],
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.getStats();
      this.getDailyTrafic();
    });
  },

  watch: {
    results(val) {
      this.pending = val.dashbord.cmdpendings;
      this.commands = val.dashbord.commands;
      this.requests = val.logs.info;
      this.push = val.dashbord.cardsClient;
      this.logsSyst = val.logs.error;
      this.disk = val.freeDisk;
      this.cpuname = val.cpu.name;
      this.cpuVersion = val.cpu.version;

      this.seriesMemories = [
        parseFloat(this.results.totalRAM) || 0,
        parseFloat(this.results.freeDisk) || 0,
        parseFloat(this.results.freeRAM) || 0,
      ];

      this.seriesCPU = [
        parseFloat(this.results.cpu.nbrCPU) || 0,
        parseFloat(this.results.cpu.systemLoadAverage) || 0,
      ];

      this.serieslogs = [
        parseFloat(this.results.logs.error) || 0,
        parseFloat(this.results.logs.info) || 0,
        parseFloat(this.results.logs.warn) || 0,
      ];
    },
  },

  created() {
    this.timer = setInterval(this.refresh, 60000)
  },

  methods: {
    refresh() {
      this.getStats();
      this.getDailyTrafic();
    },
    getStats() {
      const token = sessionStorage.getItem("token");
      if (token) {
        apiClient
            .get(`${this.$store.getters.user.baseUrl}/admin/resources`)
            .then(response => {
              console.log("API Response:", response.data.datas);
              this.results = response.data.datas;
            })
            .catch(error => {
              console.log("Dashboard")
            });
      }
    },
    cancelAutoUpdate() {
      clearInterval(this.timer)
    },
    getDailyTrafic() {
      let headerLine = {
        H00: 0,
        H01: 0,
        H02: 0,
        H03: 0,
        H04: 0,
        H05: 0,
        H06: 0,
        H07: 0,
        H08: 0,
        H09: 0,
        H10: 0,
        H11: 0,
        H12: 0,
        H13: 0,
        H14: 0,
        H15: 0,
        H16: 0,
        H17: 0,
        H18: 0,
        H19: 0,
        H20: 0,
        H21: 0,
        H22: 0,
        H23: 0,
      };
      apiClient
          .get(`${this.$store.getters.user.baseUrl}/logs/all`)
          .then(res => {
            // Destroy existing chart if it exists to prevent duplicate/conflicts
            if (this.lineChart) {
              this.lineChart.destroy();
            }

            if (res.status === 200) {
              res.data.datas.forEach(v => {
                if (v.dateLog !== null) {
                  const key = "H" + v.dateLog.slice(11, 13);
                  headerLine["" + key] = headerLine[key] + 1;
                }
              });
            }
            this.valuesLine = [
              headerLine.H00,
              headerLine.H01,
              headerLine.H02,
              headerLine.H03,
              headerLine.H04,
              headerLine.H05,
              headerLine.H06,
              headerLine.H07,
              headerLine.H08,
              headerLine.H09,
              headerLine.H10,
              headerLine.H11,
              headerLine.H12,
              headerLine.H13,
              headerLine.H14,
              headerLine.H15,
              headerLine.H16,
              headerLine.H17,
              headerLine.H18,
              headerLine.H19,
              headerLine.H20,
              headerLine.H21,
              headerLine.H22,
              headerLine.H23,
            ];
            if (this.$refs.linechart) {
              const options = {
                chart: {
                  type: "line",
                  toolbar: {
                    show: false,
                  },
                },
                colors: ["#03A9F4"],
                dataLabels: {
                  enabled: true,
                },
                stroke: {
                  curve: "smooth",
                  width: ["4"],
                },
                grid: {
                  borderColor: "#e7e7e7",
                  row: {
                    colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                    opacity: 0.5,
                  },
                },
                legend: {
                  position: "top",
                  horizontalAlign: "left",
                  floating: true,
                  offsetY: -25,
                  offsetX: -5,
                },
                series: [
                  {
                    name: "logs",
                    data: this.valuesLine,
                  },
                ],
                xaxis: {
                  categories: [
                    "00H",
                    "01H",
                    "02H",
                    "03H",
                    "04H",
                    "05H",
                    "06H",
                    "07H",
                    "08H",
                    "09H",
                    "10H",
                    "11H",
                    "12H",
                    "13H",
                    "14H",
                    "15H",
                    "16H",
                    "17H",
                    "18H",
                    "19H",
                    "20H",
                    "21H",
                    "22H",
                    "23H",
                  ],
                },
              }
              this.lineChart = new ApexCharts(this.$refs.linechart, options);
              this.lineChart.render();
            }
          })
          .catch(error => {
            console.log("Dashboard")
          });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    if (this.lineChart) {
      this.lineChart.destroy();
    }
  },
};
</script>
